import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Slide from './Slide';
import fh from '../../../../helpers/form.helper';
import ModelService from '../../../../services/slide.service';
import CardLoading from '../../../../components/CardLoading';
import WithLoading from '../../../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../../../reducers/upload';

const imageSelector = uploadSelectors.getTempFile('image');
const videoSelector = uploadSelectors.getTempFile('video');

const defaultFormData = {
  title: '',
  subtitle: '',
  url: '',
  status: ModelService.ACTIVE,
  priority: 100,
  ml: {},
};

const mapStateToProps = state => ({
  image: imageSelector(state),
  video: videoSelector(state),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { isNewModel, history, formData, t, image, video } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    image: image && image.id ? image.id : '',
    video: video && video.id ? video.id : '',
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.removeTempFile('image');
    props.removeTempFile('video');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  ...fh.defaultRecompose(defaultFormData),
  defaultProps({
    getImage: ModelService.getImage,
    getVideo: ModelService.getVideo,
  }),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
    },
  }),
  withProps(props => ({
    title: props.t('Slide') + fh.getTitleEnd(props),
    imageSrc: props.image && props.image.url
      ? props.image.url : ModelService.getImage(props.formData.image, 150, 150),
    videoUrl: props.video && props.video.url
      ? props.video.url : props.getVideo(props.formData.video),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    onChangeMl: fh.onChangeFormDataMlElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Slide, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/content/slides/slide/index.js